import { useState } from "react";
import { Tooltip, Typography } from "@mui/material";
import MUIButton from "../MUIButton/MUIButton";
import classes from "./Sources.module.css";

export default function Sources({ sources, fullSourceData, selectedInput }) {
  const [visibleCount, setVisibleCount] = useState(5);
  const sourceData = Object.values(fullSourceData || {})?.[0] || {};
  const filteredSources =
    sources?.filter((source) => !source.includes("vertexaisearch")) || [];
  const visibleSources = filteredSources.slice(0, visibleCount);

  const renderTooltipContent = (source) => {
    const aliases = sourceData?.[source]?.aliases || [];
    const urlMap = {};
    aliases.forEach(alias => {
      const url = alias?.source_alias_url;
      if (!url) return;
      const status = alias?.http_status;

      if (!urlMap[url]) {
        urlMap[url] = { url, http_status: status };
      } else {
        // if any has 200, mark as 200
        if (status === "200" || urlMap[url].http_status === "200") {
          urlMap[url].http_status = "200";
        }
      }
    });

    const uniqueUrls = Object.values(urlMap);
    if (uniqueUrls.length === 0) return null;

    return (
      <div
        style={{
          paddingRight: 8,
          maxHeight: 250,
          overflowY: "auto",
        }}
      >
        {uniqueUrls.map((item, i) => {
          const isLink = item.http_status === "200" || selectedInput.llm === "gpt-5-search-enabled";
          return (
            <div key={i} style={{ marginBottom: 6 }}>
              <Typography
                component={isLink ? "a" : "span"}
                {...(isLink && {
                  href: item.url,
                  target: "_blank",
                  rel: "noopener noreferrer",
                })}
                style={{
                  display: "block",
                  color: isLink ? "lightblue" : "lightgray",
                  textDecoration: isLink ? "underline" : "none",
                  cursor: isLink ? "pointer" : "not-allowed",
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                }}
              >
                {item.url}
              </Typography>

              {i < uniqueUrls.length - 1 && (
                <hr style={{ borderColor: "white", margin: "6px 0" }} />
              )}
            </div>
          );
        })}

      </div>
    );
  };

  return (
    <>

      <div
        style={{
          maxHeight: 300,
          overflowY: "auto",
        }}
      >
        <ul className={classes.source_list}>
          {visibleSources.map((source, index) => (
            <li key={index} className={classes.source_item}>
              <Tooltip
                title={renderTooltipContent(source)}
                placement="top-start"
                arrow
                disableInteractive={false}
              >
                <Typography
                  style={{
                    // color: "blue",
                    cursor: "pointer",
                    textDecoration: "underline",
                  }}
                >
                  {source}
                </Typography>
              </Tooltip>
            </li>
          ))}
        </ul>
      </div>

      {visibleCount < filteredSources.length && (
        <MUIButton
          style={{
            textAlign: "center",
            padding: "1px",
            fontWeight: "400",
            backgroundColor: "white",
            width: "55%",
            marginTop: "-8px",
          }}
          variant="text"
          onClick={() => setVisibleCount((prev) => prev + 5)}
        >
          Load More Sources
        </MUIButton>
      )}
    </>
  );
}
